import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

import MachineStatusModal from "routes/machine/modals/MachineStatusModal";

export function MachineTableActionButtons({
  selectedIds = [],
  selectedData = [],
  uncheckAll,
  invalidateData,
  caseRouteId,
}) {
  const navigate = useNavigate();
  const hasSelection = selectedData.length > 0;
  // Opening the map is a navigation, not something done to a selection, so the
  // menu has to stay reachable with nothing checked when the map is offered.
  const hasMap = !!caseRouteId;

  return (
    <Dropdown
      text="Actions"
      className="button mini"
      disabled={!hasSelection && !hasMap}
    >
      <Dropdown.Menu direction="left">
        {hasMap && (
          <Dropdown.Item
            content="View Map"
            icon="map marker alternate"
            onClick={() => navigate(`/cases/${caseRouteId}/map`)}
          />
        )}
        {hasSelection && (
          <MachineStatusModal
            machineIds={selectedIds}
            fetchFn={() => {
              invalidateData();
              uncheckAll();
            }}
            isDropdownButton={true}
          />
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
